import { render, staticRenderFns } from "./branchDetail.vue?vue&type=template&id=7bd950bb&"
import script from "./branchDetail.vue?vue&type=script&lang=js&"
export * from "./branchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports